export default __webpack_public_path__ + "img/16832bebd12ee036c29ba76b7a02d971.svg";